import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { CleverTapConstents } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-loan-details',
  templateUrl: './loan-details.component.html',
  styleUrls: ['./loan-details.component.scss']
})
export class LoanDetailsComponent implements OnInit {

  value: number = 0;
  tenurePopup: boolean = false;
  course: any;
  tenureData: any = [];
  selectedTebure: any = {};
  processType: any;
  isfullamt: boolean = true;
  customAmount: number = 0;
  productCat: any;
  largestFee: number = 0;
  formator = new Intl.NumberFormat('en-IN',);
  showCustomAmtValidation: boolean = false;
  minTenor: number = 0;
  maxTenor: number = 0;
  standardEmi: any = [];
  noCostEmit: any = [];
  isNoCostEmi: boolean = true;

  get getLargetFees() {
    if (!this.course) {
      return null;
    }
    this.largestFee = Math.max(this.course?.fee?.map((fee: any) => parseFloat(fee.termFee)));
    return this.formator.format(this.largestFee);
  }

  get monthlyEMI() {
    const minLoanAmount = this.productCat.config.minLoanAmount;
    const minInterestRate = this.productCat.config.minInterestRate;
    const tenor = this.tenureData.length ? this.selectedTebure.tenor : this.value;
    let amount = this.customAmount >= minLoanAmount ? this.customAmount <= this.largestFee? this.customAmount: this.largestFee : minLoanAmount;
    if (this.isfullamt) {
      amount = +(this.largestFee || 0);
    }

    return tenor > 0 ? this.formator.format(this.util.monthlyEMI(+minInterestRate, +tenor, +amount)) : 0;
  }

  monthlyEMICalc(minInterestRate: number, tenor: number, amount: number) {
    return this.util.monthlyEMI(minInterestRate, tenor, amount);
  }

  get isValid(): boolean {
    let valid = true;
    const minLoanAmount = this.productCat.config.minLoanAmount;
    const tenor = this.tenureData.length ? this.selectedTebure.tenor : this.value;
    let amount = this.customAmount;
    if (this.isfullamt) {
      amount = +(this.largestFee || 0);
    }
    if (!tenor || !amount || amount < minLoanAmount || amount > this.largestFee) {
      valid = false;
    }
    return valid;
  }
  constructor(
    private util: UtilService
  ) { }

  ngOnInit(): void {
    this.productCat = this.util.getCache('productCat');
    if (!this.productCat) {
      this.util.route('home');
    }
    this.customAmount = this.productCat?.config?.minLoanAmount;
    const loanData = this.util.loanDetails;
    this.maxTenor = loanData?.institutionInfo.maxTenor;
    this.minTenor = loanData?.institutionInfo.minTenor;
    this.value = loanData?.institutionInfo.minTenor;
    this.getInstituteData(loanData);

    console.log(loanData);
  }

  upgrade(institute: any) {
    if (!this.tenureData.length) {
      this.tenureData = [];
      for (let i = this.minTenor;
        i <= this.maxTenor; i++) {
        this.tenureData.push({
          "institution_id": institute.id,
          "tenor": i,
          "ref_institution_id": institute.id,
          "interest_rate": 0,
          "subvention": 0,
          "customer_roi": this.productCat.config.minInterestRate,
          "processing_fee": 0,
          "emi_type": "standard"
        }
        );
      }
    }
    this.standardEmi = this.tenureData.filter((res: any) => res.emi_type === 'standard' || res.emi_type === 'hybrid');
    this.noCostEmit = this.tenureData.filter((res: any) => res.emi_type === 'nocost');
    this.isNoCostEmi = !!this.noCostEmit.length;
  }

  getInstituteData(loanData: any) {
    this.util.handleRequests('get', this.util.getUrl('institute_data', [loanData?.institutionId]), undefined, undefined, undefined, false).then((instituteRes: any) => {

      const institute = instituteRes.content;
      this.processType = loanData?.institutionInfo?.processType;


      this.course = institute.courses.find((course: any) => course.courseId === loanData.institutionInfo.courseId);
      this.getTenureData(institute);

    });
  }

  getTenureData(institute: any) {
    this.util.handleRequests('get', this.util.getUrl('institute_fixedtenures', [institute.id, this.course.courseId])).then((tenure: any) => {

      this.tenureData = tenure && tenure.sort((a: any, b: any) => a.tenor - b.tenor) || [];
      if (this.tenureData.length == 1) {
        this.selectedTebure = this.tenureData[0];
      }
      if (this.processType === '2') {
        this.upgrade(institute);
      }
    });
  }

  getTableRows(){
    return this.isNoCostEmi?  this.noCostEmit : this.standardEmi
  }

  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }

  openTenurePopup() {
    this.isNoCostEmi = (!this.selectedTebure.tenor || this.selectedTebure.emi_type === 'nocost') && !!this.noCostEmit.length; 
    this.tenurePopup = true;
  }




  goToHome() {
    this.util.route('home');
  }

  validateNumber(ev: any) {
    const arr = ev.target.value?.toString().split('') || [];
    const value = +ev.target.value;
    if (!(value) && value !== 0)
      arr.pop();
    ev.target.value = +(arr.join(''));



  }
  get totalAmount() {
    let amount = this.customAmount;
    if (this.isfullamt) {
      amount = +(this.largestFee || 0);
    }
    return amount;
  }

  submit() {
    const tenor = this.tenureData.length ? this.selectedTebure.tenor : this.value;
    let amount = this.customAmount;
    if (this.isfullamt) {
      amount = +(this.largestFee || 0);
    }

    const emiType = this.selectedTebure.tenor ? this.selectedTebure.emi_type : 'standard';

    const body = {
      'amount': amount,
      'tenorMonths': tenor,
      'emiType': emiType
    };

    this.util.handleRequests('put', this.util.getUrl('loan_updateCommercials', [this.util.loanDetails.loanId]), body).then((res: any) => {
      this.util.getLoandetails().then(() => {
        this.util.navigationHandler();
        this.util.cleverTapEventCall(CleverTapConstents.fill_the_loan_details,{
        'coachingName': this.util.loanDetails?.institutionInfo.employerName !== null ?this.util.loanDetails?.institutionInfo.employerName: this.util.loanDetails?.institutionInfo.coachingCenterId,
        'courseName':this.util.getCache('currentInstituteCourses'),
        'amount': this.util.loanDetails?.institutionInfo?.amount,
        'tenure': this.util.loanDetails?.institutionInfo?.tenorMonths,
        'loanId': this.util.loanDetails.loanId,
        'productCode':this.util.loanDetails.productCategory})
      });
    })


  }

}
